import React from 'react';

import styled from 'styled-components';

import CommunitiesControlsFilters from './CommunitiesControlsFilters';
import CommunitiesControlsSearch from './CommunitiesControlsSearch';
import CommunitiesHeaderActions from './CommunitiesHeaderActions';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  gap: 20px;
`;

const PrimeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
`;

const CommunitiesControls = () => {
  return (
    <Container>
      <PrimeContainer>
        <CommunitiesControlsSearch />
        <CommunitiesHeaderActions />
      </PrimeContainer>

      <CommunitiesControlsFilters />
    </Container>
  );
};

export default CommunitiesControls;
